/* Filigree Wishlist — localStorage + Omnisend email capture */
(function () {
  'use strict';

  var WL = {
    KEY: 'fg_wishlist',
    EMAIL_KEY: 'fg_wishlist_email',

    getAll: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
      catch (e) { return []; }
    },
    _save: function (items) {
      try { localStorage.setItem(this.KEY, JSON.stringify(items)); }
      catch (e) {}
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
    },
    has: function (id) {
      id = String(id);
      return this.getAll().some(function (p) { return String(p.id) === id; });
    },
    add: function (product) {
      var items = this.getAll();
      var id = String(product.id);
      if (!items.some(function (p) { return String(p.id) === id; })) {
        items.push(product);
        this._save(items);
      }
    },
    remove: function (id) {
      id = String(id);
      var items = this.getAll().filter(function (p) { return String(p.id) !== id; });
      this._save(items);
    },
    toggle: function (product) {
      if (this.has(product.id)) { this.remove(product.id); return false; }
      this.add(product);
      return true;
    },
    count: function () { return this.getAll().length; },
    getEmail: function () { try { return localStorage.getItem(this.EMAIL_KEY); } catch (e) { return null; } },
    setEmail: function (email) { try { localStorage.setItem(this.EMAIL_KEY, email); } catch (e) {} }
  };

  function syncHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = WL.has(btn.dataset.productId);
      btn.classList.toggle('wl-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
    });
    var badge = document.querySelector('[data-wl-count-badge]');
    if (badge) {
      var c = WL.count();
      badge.textContent = c;
      badge.style.display = c > 0 ? 'flex' : 'none';
    }
  }

  var _toastTimer;
  function showToast(msg) {
    var t = document.getElementById('wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'wl-toast';
      t.className = 'wl-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('wl-toast--visible');
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () { t.classList.remove('wl-toast--visible'); }, 3500);
  }

  function openModal(product) {
    var m = document.getElementById('wl-modal');
    if (!m) return;
    m.removeAttribute('hidden');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wl-no-scroll');
    var emailInput = m.querySelector('[data-wl-email]');
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 50);
    var form = m.querySelector('[data-wl-form]');
    if (!form) return;
    var newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    newForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (newForm.querySelector('[data-wl-email]').value || '').trim();
      var nameEl = newForm.querySelector('[data-wl-name]');
      var firstName = nameEl ? nameEl.value.trim() : '';
      if (!email || !email.includes('@')) {
        newForm.querySelector('[data-wl-email]').focus();
        return;
      }
      WL.setEmail(email);
      closeModal();
      try {
        window.omnisend = window.omnisend || [];
        var payload = { email: email, tags: ['wishlist_subscriber'] };
        if (firstName) payload.firstName = firstName;
        window.omnisend.push(['identify', payload]);
        window.omnisend.push(['track', 'wishlist_created', { itemCount: WL.count() }]);
      } catch (ex) {}
      showToast('Saved! Check your email for your free shipping offer.');
    });
  }

  function closeModal() {
    var m = document.getElementById('wl-modal');
    if (!m) return;
    m.setAttribute('hidden', '');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wl-no-scroll');
  }

  function fmt(cents) {
    var n = Math.round(Number(cents) || 0);
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderDrawer() {
    var items = WL.getAll();
    var list = document.querySelector('[data-wl-items]');
    var empty = document.querySelector('[data-wl-empty]');
    var hdr = document.querySelector('[data-wl-count]');
    if (hdr) hdr.textContent = items.length;
    if (!items.length) {
      if (list) list.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    if (!list) return;
    list.innerHTML = items.map(function (p) {
      var img = p.image
        ? '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="wl-item__img" width="80" height="100" loading="lazy">'
        : '<div class="wl-item__img wl-item__img--empty">&#9825;</div>';
      return '<div class="wl-item" data-wl-item-id="' + p.id + '">'
        + '<a href="' + p.url + '" class="wl-item__img-wrap">' + img + '</a>'
        + '<div class="wl-item__body">'
        + '<a href="' + p.url + '" class="wl-item__title">' + p.title + '</a>'
        + '<div class="wl-item__price">' + fmt(p.price) + '</div>'
        + '<div class="wl-item__actions">'
        + '<a href="' + p.url + '" class="wl-item__view-btn">View Product</a>'
        + '<button type="button" class="wl-item__remove" data-wl-remove="' + p.id + '" aria-label="Remove from wishlist">&times;</button>'
        + '</div></div></div>';
    }).join('');
  }

  window.openWishlistDrawer = function () {
    var d = document.getElementById('wl-drawer');
    if (!d) return;
    renderDrawer();
    d.classList.add('wl-drawer--open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wl-no-scroll');
  };

  window.closeWishlistDrawer = function () {
    var d = document.getElementById('wl-drawer');
    if (!d) return;
    d.classList.remove('wl-drawer--open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wl-no-scroll');
  };

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var product = {
        id: toggleBtn.dataset.productId,
        handle: toggleBtn.dataset.productHandle || '',
        title: toggleBtn.dataset.productTitle || '',
        image: toggleBtn.dataset.productImage || '',
        price: toggleBtn.dataset.productPrice || '0',
        url: toggleBtn.dataset.productUrl || '/'
      };
      var added = WL.toggle(product);
      syncHearts();
      if (added) {
        if (!WL.getEmail()) {
          openModal(product);
        } else {
          showToast('Saved to wishlist');
          try {
            window.omnisend = window.omnisend || [];
            window.omnisend.push(['track', 'wishlist_item_added', { productId: product.id, productTitle: product.title }]);
          } catch (ex) {}
        }
      } else {
        showToast('Removed from wishlist');
      }
      return;
    }
    var removeBtn = e.target.closest('[data-wl-remove]');
    if (removeBtn) {
      WL.remove(removeBtn.dataset.wlRemove);
      renderDrawer();
      syncHearts();
      return;
    }
    if (e.target.matches('[data-wl-modal-close]') || e.target.matches('.wl-modal__overlay')) {
      closeModal();
      return;
    }
    if (e.target.matches('[data-wl-drawer-close]') || e.target.matches('.wl-drawer__overlay')) {
      window.closeWishlistDrawer();
      return;
    }
    var openBtn = e.target.closest('[data-wl-open-drawer]');
    if (openBtn) { window.openWishlistDrawer(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); window.closeWishlistDrawer(); }
  });

  document.addEventListener('wishlist:updated', function () {
    syncHearts();
    renderDrawer();
  });

  document.addEventListener('DOMContentLoaded', syncHearts);
  window.WishlistManager = WL;
}());
